
import {RedeemCouponModel} from './redeem-coupon.model';


export class NfResumeModel {
  resumeCampaing: RedeemCouponModel;
}




// WEBPACK FOOTER //
// d:/workspace/wynk_web_shoppings_3_prod/src/models/nf-resume.model.ts